<template>
    <div class="main__dashboard__section common__page__box">
        <section class="rlms-container dashboard__section">
            <div class="group__box__wrapper">
                <div class="dashboard__content__box">
                    <div class="overview__box__wrapper">
                        <div class="section__title__box">
                            <h4 class="title">{{ auth?.user?.firstname }}'s Dashboard</h4>
                        </div>
                        <div class="data__box__wrap">
                            <div class="data__box color1">
                                <div class="data__icon">
                                    <img :src="memberIcon" />
                                </div>
                                <div class="data__details">
                                    <span class="data__title">Learner Total</span>
                                    <span class="data__output">{{ totalLearners }}</span>
                                </div>
                            </div>

                            <div class="data__box color2">
                                <div class="data__icon">
                                    <img :src="assessmentIcon" />
                                </div>
                                <div class="data__details">
                                    <span class="data__title">Assessment Completion</span>
                                    <span class="data__output">{{ completionPercentage }}%</span>
                                </div>
                            </div>

                            <div class="data__box color3">
                                <div class="data__icon">
                                    <img :src="studentIcon" />
                                </div>
                                <div class="data__details">
                                    <span class="data__title">Active Learners</span>
                                    <span class="data__output">{{ activeLearnersCount }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="learners__data__box" v-if="loading">
                        <div class="section__title__box">
                            <h4 class="title">Learners</h4>
                            <div class="view__all__btn">
                                <RouterLink to="/learners">View All</RouterLink>
                            </div>
                        </div>
                        <div class="divider__sepline"></div>

                        <div class="learner__details__box rlms-w-100">
                            <div class="learner__head__box">
                                <span class="head__title">Learner</span>
                                <span class="head__title info__popup__wrap">
                                    Subscription
                                    <i><img :src="dangerIcon" alt="Info" /></i>
                                </span>
                                <span class="head__title">Progress</span>
                                <span class="head__title">Action</span>
                            </div>

                            <div class="divider__sepline"></div>
                            <div class="rlms-w-100">
                                <SkeletonLoader />
                            </div>
                        </div>
                    </div>
                    <template v-else>
                        <div class="learners__data__box" v-if="!learners.length">
                            <div class="section__title__box">
                                <h4 class="title">Learners</h4>
                                <div class="view__all__btn">
                                    <RouterLink to="/learners">View All</RouterLink>
                                </div>
                            </div>
                            <div class="divider__sepline"></div>
                            <div class="no__learner__box">
                                <div class="inner__cover__box">
                                    <div class="img__box__wrapper">
                                        <img :src="kidsreadingbookImg">
                                    </div>
                                    <div class="no__learner__content__box">
                                        <h4 class="title">You Have No Active Learners</h4>
                                        <div class="no__learner__shortnote">
                                            <p>You don’t have any learners yet. To get started, either create an
                                                organization and add learners, or ask your organization leader to assign
                                                learners to you.</p>
                                        </div>
                                    </div>
                                    <div class="btn__box__wrapper">
                                        <div class="purchase__learner__btn">
                                            <RouterLink to="/organizations">Go To Organizations</RouterLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Learners List (Desktop/Mobile) -->
                        <div v-else :class="{
                            'learners__data__box for__desktop': !isMobile,
                            'mobile__organization__learner__details for__mobile': isMobile,
                        }">
                            <template v-if="isMobile">
                                <div class="mob__learner__details__block">
                                    <div class="title__block">
                                        <h5 class="title">Learners Details</h5>
                                        <div class="view__all__link">
                                            <RouterLink to="/learners">
                                                <span class="link__text">View All</span>
                                                <span class="link__icon">
                                                    <img :src="backArrowIcon">
                                                </span>
                                            </RouterLink>
                                        </div>
                                    </div>
                                    <div class="mob__table__header">
                                        <div class="table__head__item">
                                            Learner
                                        </div>
                                        <div class="table__head__item">
                                            Subscription
                                            <img :src="dangerIcon" alt="Info" />
                                        </div>
                                        <div class="table__head__item">
                                            Action
                                        </div>
                                    </div>
                                    <div class="mob__learner__details__card__list">
                                        <!-----learner Card item------->
                                        <div class="mob__learner__details__item" v-for="learner in learners"
                                            :key="learner.id">
                                            <div class="inner__learner__info">
                                                <span class="learner__avatar__img">
                                                    <img :src="learner.picture || learnerIcon" alt="Learner Profile" />
                                                </span>
                                                <div class="learner__personal__info">
                                                    <div class="learner__name__status">
                                                        <h6 class="name rlms-flex rlms-gap-10">{{ learner.firstname }}
                                                            {{
                                                                learner.lastname
                                                            }}
                                                            <template
                                                                v-if="!learner.is_owner && learner?.is_administrator">
                                                                <Tooltip
                                                                    :content="`<p class='rlms-p-3'>Administrator Access</p>`"
                                                                    placement="bottom">
                                                                    <template #button>
                                                                        <img :src="optionsInfoIcon" />
                                                                    </template>
                                                                </Tooltip>
                                                            </template>
                                                            <template
                                                                v-else-if="!learner.is_owner && !learner?.is_administrator && learner?.is_authorized_user">
                                                                <Tooltip
                                                                    :content="`<p class='rlms-p-3'>Group Access</p>`"
                                                                    placement="right">
                                                                    <template #button>
                                                                        <img :src="optionsInfoIcon" />
                                                                    </template>
                                                                </Tooltip>
                                                            </template>
                                                        </h6>
                                                        <span v-if="learner.subscription_status === null"
                                                            class="status_label rlms-bg-danger-400">No
                                                            Subscription</span>
                                                        <span v-else-if="learner.subscription_status"
                                                            class="status_label active">Active</span>
                                                        <span v-else
                                                            class="status_label rlms-bg-danger-400">Expired</span>
                                                    </div>
                                                    <div class="mob__learn__more">
                                                        <RouterLink
                                                            :to="`organizations/${learner.organization_id}/learners/${learner.id}/dashboard`">
                                                            <img :src="learnMoreIcon">
                                                        </RouterLink>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="learner__user__progress__bar">
                                                <div class="progress__bar__title">
                                                    <label class="progress__label">Progress</label>
                                                    <span class="progress__percent">{{ learner?.progress ?? 0 }}%</span>
                                                </div>
                                                <div class="learner__progress">
                                                    <div class="default__progressbar">
                                                        <span class="progressbar__filler"
                                                            :style="{ width: (learner?.progress ?? 0) + '%' }"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="section__title__box">
                                    <h4 class="title">Learners Details</h4>
                                    <div class="view__all__btn">
                                        <RouterLink to="/learners">View All</RouterLink>
                                    </div>
                                </div>

                                <div class="learner__details__box">
                                    <!-- Table Headers -->
                                    <div class="learner__head__box">
                                        <span class="head__title">Learner</span>
                                        <span class="head__title info__popup__wrap">
                                            Subscription
                                            <i><img :src="dangerIcon" alt="Info" /></i>
                                        </span>
                                        <span class="head__title">Progress</span>
                                        <span class="head__title">Action</span>
                                    </div>

                                    <div class="divider__sepline"></div>

                                    <!-- Learners List -->
                                    <div class="card__tablist__box">
                                        <div v-for="learner in learners" :key="learner.id" class="tablist__item">
                                            <!-- Learner Name and Profile -->
                                            <div class="learner__tab">
                                                <div class="learner__profile">
                                                    <img :src="learner.picture || learnerIcon" alt="Learner Profile" />
                                                </div>
                                                <h6 class="learner__name">{{ learner.firstname }} {{ learner.lastname }}
                                                </h6>
                                                <template v-if="!learner.is_owner && learner?.is_administrator">
                                                    <Tooltip :content="`<p class='rlms-p-3'>Administrator Access</p>`"
                                                        placement="bottom">
                                                        <template #button>
                                                            <img :src="optionsInfoIcon" />
                                                        </template>
                                                    </Tooltip>
                                                </template>
                                                <template
                                                    v-else-if="!learner.is_owner && !learner?.is_administrator && learner?.is_authorized_user">
                                                    <Tooltip :content="`<p class='rlms-p-3'>Group Access</p>`"
                                                        placement="right">
                                                        <template #button>
                                                            <img :src="optionsInfoIcon" />
                                                        </template>
                                                    </Tooltip>
                                                </template>
                                            </div>

                                            <!-- Subscription Status -->
                                            <div class="subscription__tab">
                                                <span v-if="learner.subscription_status === null"
                                                    class="inactive__label">No Subscription</span>
                                                <span v-else-if="learner.subscription_status"
                                                    class="active__label">Active</span>
                                                <span v-else class="inactive__label">Expired</span>
                                            </div>

                                            <!-- Progress Bar -->
                                            <div class="progress__tab"
                                                style="display: flex; gap:10px;font-weight: 500; color: #41B9FE;">
                                                <span>{{ learner?.progress ?? 0 }}%</span>
                                                <div class="progress__bar">
                                                    <span :style="{ width: (learner?.progress ?? 0) + '%' }"></span>
                                                </div>
                                            </div>

                                            <!-- Action Button -->
                                            <div class="action__tab">
                                                <div class="action__btn">
                                                    <RouterLink
                                                        :to="`organizations/${learner.organization_id}/learners/${learner.id}/dashboard`">
                                                        <span class="btn__text">View</span>
                                                        <span class="btn__arrow">
                                                            <img :src="arrowRightIcon" alt="Arrow" />
                                                        </span>
                                                    </RouterLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="dashboard__sidebar__box">
                    <div class="resources__box__wrapper">
                        <h3 class="title">Resources Links</h3>
                        <div class="divider__sepline"></div>
                        <div class="data__link__box">
                            <div class="link__item__box">
                                <h5 class="title">EESA eBook</h5>
                                <div class="link__group">
                                    <a href="https://datamakesthedifference.com/eesa-ebook">
                                        <span>Link</span>
                                        <img :src="linkIcon" />
                                    </a>
                                </div>
                            </div>
                            <div class="link__item__box">
                                <h5 class="title">Other Products</h5>
                                <div class="link__group">
                                    <a href="https://datamakesthedifference.com">
                                        <span>Link</span>
                                        <img :src="linkIcon" />
                                    </a>
                                </div>
                            </div>
                            <div class="link__item__box">
                                <h5 class="title">Support Center</h5>
                                <div class="link__group">
                                    <a href="https://datamakesthedifference.com/contact-us">
                                        <span>Link</span>
                                        <img :src="linkIcon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="latest__posts__wrapper">
                        <h4 class="title">Latest Posts</h4>
                        <div class="divider__sepline"></div>
                        <div class="latest__post__list__wrapper">
                            <div class="latest__posts__item" v-for="(post, index) in posts" :key="index">
                                <a :href="post.link" target="_blank">
                                    <div class="post__img__box">
                                        <img :src="post.image" />
                                    </div>
                                    <div class="post__description__box">
                                        <h5 class="title">{{ post.title }}</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import linkIcon from "@/assets/images/link.svg";
import learnerIcon from "@/assets/images/learner-icon.png";
import memberIcon from "@/assets/images/members.svg";
import assessmentIcon from "@/assets/images/assessment.svg";
import studentIcon from "@/assets/images/student.svg";
import kidsreadingbookImg from "@/assets/images/kids-reading-book.png";
import { useAuthStore } from "@/stores/auth";
import { RouterLink } from "vue-router";
import api from "@/services/axios";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { handleError } from "@/utils/handleError";
import { useLoaderStore } from "@/stores/loader";
import SkeletonLoader from "@/components/skeleton/SkeletonLoader.vue";
import dangerIcon from '@/assets/images/danger.svg'
import backArrowIcon from '@/assets/images/back-arrow-icon.png'
import learnMoreIcon from '@/assets/images/mob-learn-more-icon.png'
import arrowRightIcon from '@/assets/images/arrow-right.svg'
import Tooltip from "@/components/Tooltip.vue";
import optionsInfoIcon from '@/assets/images/options-info-icon.png';

const auth = useAuthStore();

const loader = useLoaderStore();

const learners = ref([]);
const totalLearners = ref(0);
const activeLearnersCount = ref(0);
const completionPercentage = ref(0);

const screenWidth = ref(window.innerWidth);
const isMobile = computed(() => screenWidth.value < 768);
const updateWidth = () => {
    screenWidth.value = window.innerWidth;
};

const loading = computed(() => {
    return loader.loading;
});

onMounted(() => {
    window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
});

const posts = [
    {
        link: 'https://datamakesthedifference.com/what-is-the-eesapp/',
        image: new URL('@/assets/images/post1.png', import.meta.url).href,
        title: 'Get ready for an amazing tool to help assess a learner’s echoic skills in terms...'
    },
    {
        link: 'https://datamakesthedifference.com/essential-for-living/',
        image: new URL('@/assets/images/post2.png', import.meta.url).href,
        title: 'Essential for Living: Comprehensive, function-based assessment...'
    },
    {
        link: 'https://datamakesthedifference.com/what-is-the-vb-mapp-and-who-is-it-for/',
        image: new URL('@/assets/images/post3.png', import.meta.url).href,
        title: 'Verbal Behavior Milestones Assessment & Placement Program  (VB-MAPP) by mark...'
    }
];


onMounted(() => {
    fetchData();
})

const fetchData = async () => {
    try {
        loader.show();
        const response = await api.get(`/dashboard`);
        learners.value = response?.data?.data?.learners || [];
        totalLearners.value = response?.data?.data?.totalLearners || 0;
        activeLearnersCount.value = response?.data?.data?.activeLearnersCount || 0;
        completionPercentage.value = response?.data?.data?.completion_percentage || 0;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}
</script>